import React from "react";
import dumyimage from "../../assets/dumyimage.png";

function DummyImage({ customClass = "" }) {
  return (
    <div className="h-auto">
      <img
        className={`w-10 h-10 rounded-full max-w-xs ${customClass}`}
        src={dumyimage}
        alt="profileimage"
      />
    </div>
  );
}

export default DummyImage;
